import { render, staticRenderFns } from "./KousakuAddress.vue?vue&type=template&id=4857b5ba&scoped=true&"
import script from "./KousakuAddress.vue?vue&type=script&lang=js&"
export * from "./KousakuAddress.vue?vue&type=script&lang=js&"
import style0 from "./KousakuAddress.vue?vue&type=style&index=0&id=4857b5ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4857b5ba",
  null
  
)

export default component.exports